import React from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import PropTypes from 'prop-types'
import { useStyles, MenuPaper } from '../styles'

const Source = ({ selectedValue, options, onChange, label, labelId, ...rest }) => {
  const classes = useStyles()

  return (
    <FormControl
      variant="outlined"
      margin="dense"
      className={classes.formControl}
    >
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        value={selectedValue}
        onChange={onChange}
        label={label}
        fullWidth
        MenuProps={{
          PaperProps: {
            component: MenuPaper,
            elevation: 0
          },
        }}
        {...rest}
      >
        {options.map((option) => (
          <MenuItem key={option.uuid} value={option.uuid}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

Source.defaultProps = {
  label: '',
  labelId: '',
  onChange: () => {},
}

Source.propTypes = {
  selectedValue: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    })
  ).isRequired,
  onChange: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelId: PropTypes.string,
}

export default Source
